<div class="appraisal-guide-shell">
  <button
    *ngIf="dismissed"
    type="button"
    class="btn btn-outline-secondary appraisal-guide-reopen"
    (click)="showGuide()"
  >
    <i class="fa fa-map-signs" aria-hidden="true"></i>
    <span translate>APPRAISAL_GUIDE_SHOW</span>
  </button>

  <section *ngIf="!dismissed" class="appraisal-guide-banner">
    <div class="guide-banner-copy">
      <div class="guide-banner-kicker">
        <span class="guide-kicker" translate>APPRAISAL_GUIDE_TOUR_BADGE</span>
        <span class="guide-role-badge">{{ roleBadgeKey | translate }}</span>
      </div>
      <div *ngIf="canShowGuideRoleSelector" class="guide-role-selector" role="group">
        <span class="guide-role-selector-label" translate>APPRAISAL_GUIDE_ROLE_SELECTOR</span>
        <button
          type="button"
          class="btn btn-sm guide-role-option"
          [class.active]="selectedGuideRole === 'manager'"
          (click)="selectGuideRole('manager')"
        >
          {{ 'APPRAISAL_GUIDE_ROLE_MANAGER' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-sm guide-role-option"
          [class.active]="selectedGuideRole === 'employee'"
          (click)="selectGuideRole('employee')"
        >
          {{ 'APPRAISAL_GUIDE_ROLE_EMPLOYEE' | translate }}
        </button>
      </div>
      <h3>{{ bannerTitleKey | translate }}</h3>
      <p>{{ bannerBodyKey | translate }}</p>
    </div>

    <div class="guide-banner-actions">
      <button type="button" class="btn btn-primary" (click)="startTour()">
        <i class="fa fa-play-circle-o" aria-hidden="true"></i>
        <span translate>APPRAISAL_GUIDE_START_TOUR</span>
      </button>
      <button
        type="button"
        class="btn btn-link guide-close"
        (click)="dismissGuide()"
      >
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </section>

  <div *ngIf="tourActive && currentTourStep" class="guide-tour-overlay">
    <div class="guide-tour-backdrop"></div>
    <div class="guide-tour-spotlight" [ngStyle]="spotlightStyle"></div>

    <section class="guide-tour-card" [ngStyle]="cardStyle">
      <div class="guide-tour-card-header">
        <span class="guide-tour-progress">
          {{ 'STEP' | translate }} {{ currentTourStepIndex + 1 }}/{{ tourSteps.length }}
        </span>
        <button
          type="button"
          class="btn btn-link guide-close"
          (click)="closeTour()"
        >
          {{ 'CLOSE' | translate }}
        </button>
      </div>

      <h4>{{ currentTourStep.titleKey | translate }}</h4>
      <p>{{ currentTourStep.bodyKey | translate }}</p>

      <div class="guide-tour-card-actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="previousStep()"
          [disabled]="!hasPreviousStep"
        >
          {{ 'PREVIOUS' | translate }}
        </button>

        <span *ngIf="isCurrentStepActive" class="guide-current-chip">
          {{ 'APPRAISAL_GUIDE_YOU_ARE_HERE' | translate }}
        </span>

        <button
          *ngIf="isCurrentStepOpenable && !isCurrentStepActive"
          type="button"
          class="btn btn-outline-primary"
          (click)="openCurrentStepTab()"
        >
          {{ 'APPRAISAL_GUIDE_OPEN_TAB' | translate }}
        </button>

        <button type="button" class="btn btn-primary" (click)="nextStep()">
          {{ finishButtonKey | translate }}
        </button>
      </div>
    </section>
  </div>
</div>
